import { render, staticRenderFns } from "./MessageButton.vue?vue&type=template&id=349aa7b0&scoped=true&"
import script from "./MessageButton.vue?vue&type=script&lang=js&"
export * from "./MessageButton.vue?vue&type=script&lang=js&"
import style0 from "./MessageButton.vue?vue&type=style&index=0&id=349aa7b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349aa7b0",
  null
  
)

export default component.exports